module.exports = __webpack_public_path__ + "static/media/cluster_6.b2047d6d.webp";